import { createStore } from 'vuex'


export default createStore({
  state: {
    isAutenticated:false,
    configuracionPortal: null as any,
    pacienteLogueado:null as any,
    pacientePadre:null as any,
    pacientesRelacionados:null as any,
    isLoading:false,
    embed: false,
  },
  mutations: {
    SET_AUTH (state, {pacienteLogueado,bool}){
      state.isAutenticated = bool
      state.pacienteLogueado = pacienteLogueado;
      state.pacientePadre = pacienteLogueado;
      state.pacientesRelacionados = pacienteLogueado?.pacientesRelacionados || null;
    },
    SET_CONFIG(state , config){
      state.configuracionPortal = config;
    },
    SET_LOAD(state , bool){
      state.isLoading = bool;
    },
    SET_PACIENTE(state, paciente){
      
      const index = state.pacientesRelacionados.findIndex((pacienteRelacionado:any) => pacienteRelacionado.id === paciente.id )
      const pacienteActual = state.pacienteLogueado;

      if(index === -1){
        return;
      }
      
      state.pacientesRelacionados.splice(index,1,{...pacienteActual});
      state.pacienteLogueado = {...paciente};
    },
    SET_EMBED(state,bool){
      state.embed = bool;
    }
  },
  actions: {
    autenticar({commit},datos){
      commit('SET_AUTH',{pacienteLogueado:datos,bool:true});
    },
    cerrarSesion({commit}){
      commit('SET_AUTH',{pacienteLogueado:null,bool:true});
    },
    cambiarPaciente({commit},paciente){
      commit('SET_PACIENTE',paciente);
    },
    setEmbed({commit},bool){
      commit('SET_EMBED',bool);
    }
  },
  getters:{
    hasMedicosPermitidos: (state) => {
      const especialidades = state?.configuracionPortal?.parametros?.especialidades
      return especialidades.top.length > 0 || especialidades.children.length > 0;
    },
    coberturaPermitida: (state) => {
      
      const coberturas = state.configuracionPortal.parametros.coberturas;
      const paciente = state.pacienteLogueado;
      const esValido = coberturas.top.some((cob:any) => cob === paciente.idcobertura) 
              || coberturas.children.some((plan:any) => plan === paciente.idplancobertura);


      return esValido;
    },
    isOrdenesActive: (state) => {
      const config = state.configuracionPortal;
      return config.mostrar_ordenes;
    },
    isHistoricoCitasActive: (state) => {
      return state.configuracionPortal.historico_citas;
    },
    coberturaParticular: (state) => {
      return state.configuracionPortal.cobertura;
    },
    coberturaRequierePago: (state) => {
      const paciente = state.pacienteLogueado;
      const coberturas = state.configuracionPortal.parametros.coberturasCobro
      const top = coberturas.top || [];
      const children = coberturas.children || [];
      const esValido = top.some((cob:any) => cob === paciente.idcobertura) 
        || children.some((plan:any) => plan === paciente.idplancobertura);
      return esValido;
    },
    profesionalRequiereCobro: (state) => (idespecialidad:number, idmedicoespecialidad:number) => {
      const profesionales = state.configuracionPortal.parametros.profesionalesCobro;
      const medicoEspecialidadPermitidos = profesionales.children || [];
      const especialidadesPermitidas = profesionales.top || [];
      const esValido = especialidadesPermitidas?.includes(idespecialidad) 
        || medicoEspecialidadPermitidos?.includes(idmedicoespecialidad);
      return esValido;
    },
    getUrlBase(){
      const host = window.location.host 
      const subdomain = host.split('.')[0]
      if(subdomain === 'testing-portal'){
          return 'https://testing.notifications.globalapp.ar'
      } else if(subdomain === 'portal') {
          return 'https://notifications.globalapp.ar'
      } else {
          return 'http://localhost:4000/views'
      }
    },
    descripcionCliente: (state) => {
      const cliente = state.configuracionPortal.cliente

      return cliente.nombrefantasia || cliente.descripcion || ''
    },
     profesionalPermiteEliminar: (state) => (idespecialidad:number, idmedicoespecialidad:number) => {
      if(!state.configuracionPortal?.eliminacion_citas_especialidad) return true;
      const profesionales = state.configuracionPortal.parametros.especialidadesEliminacion;
      const medicoEspecialidadPermitidos = profesionales?.children || [];
      const especialidadesPermitidas = profesionales?.top || [];
      const esValido = especialidadesPermitidas.includes(idespecialidad) 
        || medicoEspecialidadPermitidos.includes(idmedicoespecialidad);
      return esValido;
    },

  },
  modules: {
  }
})
